import { createIcon } from './create-icon'

export const WarningO = createIcon({
  displayName: 'WarningO',
  paths: [
    'M512 725.333c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667zM554.667 512c0 23.552-19.115 42.667-42.667 42.667s-42.667-19.115-42.667-42.667v-170.667c0-23.552 19.115-42.667 42.667-42.667s42.667 19.115 42.667 42.667v170.667zM512 170.667c-188.501 0-341.333 152.832-341.333 341.333s152.832 341.333 341.333 341.333c188.501 0 341.333-152.832 341.333-341.333s-152.832-341.333-341.333-341.333z'
  ]
})
